__webpack_require__.p = "/project-smart-coders-frontend/";